import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div className="min-h-screen grid place-items-center text-[var(--text-ink)]/60">
                Loading…
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (!user.role) return <Navigate to="/choose-role" replace />;
    return children;
}
